import React from 'react'
import classNames from 'classnames'
import { gsap, ScrollTrigger } from 'gsap/all'

import ExpandableText from './expandable-text'
import TitleCredits from './title-credits'

gsap.registerPlugin(ScrollTrigger)

class SimpleImage extends React.Component {
    constructor(props) {
        super(props)

        this.domRef = React.createRef()
    }

    componentDidMount() {
        if (!this.props.disableAnimation)
            document.addEventListener('allimagesloaded', () => {
                gsap.from(this.domRef.current, {
                    opacity: 0,
                    scale: this.props.horizontal ? 0.9 : 1,
                    scrollTrigger: {
                        trigger: this.domRef.current,
                        toggleActions: 'restart',
                        start: 'top bottom',
                        end: 'top center',
                        scrub: true
                    }
                })
            })
    }

    render() {
        const { imageRef, maxWidth, horizontal, expandableCaption, caption, children, title, artist, year, credit } = this.props

        const style = {
            maxWidth: maxWidth
        }

        return (
            <figure className={classNames('simple-image', horizontal && 'horizontal', maxWidth === '100%' && 'full-width')} style={style} ref={this.domRef}>
                <div className="image">
                    <img src={imageRef} alt={caption} />
                    {!horizontal &&
                        <TitleCredits 
                            title={title} 
                            artist={artist} 
                            year={year} 
                            credit={credit} 
                        />
                    }
                    <figcaption>
                        {expandableCaption ?
                            <ExpandableText>
                                {caption ? caption : children}
                            </ExpandableText>
                        :
                            caption ? caption : children
                        }
                    </figcaption>
                </div>
                {horizontal &&
                    <TitleCredits 
                        title={title} 
                        artist={artist} 
                        year={year} 
                        credit={credit} 
                    />
                }
            </figure>
        )
    }
}

export default SimpleImage